// src/screens/ReceResults/ReceResults.jsx

import React from "react";
import { Link } from "react-router-dom";
import "./ReceResults.css";

export default function ReceResults({ groupEvents, eventDetails, sessions, loading, onEventSelect }) {
  // Helper function to filter and remove duplicates
  const filterUniqueResults = (results, filterKey) => {
    const seen = new Set();
    return results.filter((result) => {
      const key = result[filterKey];
      if (key && !seen.has(key)) {
        seen.add(key);
        return true;
      }
      return false;
    });
  };

  return (
    <div className="rece-results">
      <h2>Race Event Results</h2>
      <div className="event-dropdown-container">
        <select className="event-dropdown" onChange={(e) => onEventSelect(e.target.value)} defaultValue="">
          <option value="" disabled>
            Select an Event
          </option>
          {groupEvents.map((event) => (
            <option key={event.id} value={event.id}>
              {event.name}
            </option>
          ))}
        </select>
      </div>

      {loading && <div style={{ color: "#FF4600", textAlign: "center" }}>Loading...</div>}

      {!loading && eventDetails && (
        <div className="event-details">
          <h3>{eventDetails.eventName} Summary</h3>
          <table>
            <thead>
              <tr>
                <th>Pos</th>
                <th>Driver</th>
                <th>Qual Points</th>
                <th>Race Points</th>
                <th>Best Prac Lap</th>
                <th>Best Qual Lap</th>
                <th>Best Race Lap</th>
                <th>Wins</th>
                <th>Total Points</th>
              </tr>
            </thead>
            <tbody>
              {filterUniqueResults(eventDetails.eventResults, "customer_id").map((result, index) => (
                <tr key={index}>
                  <td>{result.position}</td>
                  <td>
                    {result.customer_id ? (
                      <Link to={`/driver/${result.customer_id}`} className="driver-link">
                        {result.customer_name}
                      </Link>
                    ) : (
                      <span>{result.customer_name || "Unknown Driver"}</span>
                    )}
                  </td>
                  <td>{result.qualification_points}</td>
                  <td>{result.race_points}</td>
                  <td>{result.fastest_practice_lap_time_str || "-"}</td>
                  <td>{result.fastest_qualification_lap_time_str || "-"}</td>
                  <td>{result.fastest_race_lap_time_str || "-"}</td>
                  <td>{result.race_wins}</td>
                  <td>{result.total_points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && sessions.length > 0 && (
        <div className="session-details">
          {sessions.map((session, index) => (
            <div key={index} className="session-section">
              <h3>{`${session.sessionName} :: ${session.circuitName}`}</h3>
              <table>
                <thead>
                  <tr>
                    <th>Pos</th>
                    <th>Driver</th>
                    <th>Vehicle</th>
                    <th>Difference</th>
                    <th>Best Lap</th>
                    <th>Race Points</th>
                    <th>Penalty Points</th>
                    <th>Total Points</th>
                  </tr>
                </thead>
                <tbody>
                  {filterUniqueResults(session.results, "customer_id").map((result, i) => (
                    <tr key={i}>
                      <td>{result.position}</td>
                      <td>
                        {result.customer_id ? (
                          <Link to={`/driver/${result.customer_id}`} className="driver-link">
                            {result.customer_name}
                          </Link>
                        ) : (
                          <span>{result.customer_name || "Unknown Driver"}</span>
                        )}
                      </td>
                      <td>{result.vehicle_name || "-"}</td>
                      <td>{result.difference || "-"}</td>
                      <td>{result.best_lap || "-"}</td>
                      <td>{result.points || "-"}</td>
                      <td>{result.penalty_points || "-"}</td>
                      <td>{result.total_points || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
